var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProgrssWithTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: 44,
    viewBox: "0 0 344 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "progrss_with_trophy",
    transform: "translate(-36 -342)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1815",
    "data-name": "Group 1815",
    transform: "translate(0 -31)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1808",
    "data-name": "Group 1808",
    transform: "translate(-2 8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_893",
    "data-name": "Rectangle 893",
    width: 343,
    height: 11,
    rx: 5.5,
    transform: "translate(38 384)",
    fill: "#bbbbbf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_894",
    "data-name": "Rectangle 894",
    width: 342,
    height: 11,
    rx: 5.5,
    transform: "translate(38 384)",
    fill: "#75baf5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1777",
    "data-name": "Group 1777",
    transform: "translate(-17.542 -30.885)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2520",
    "data-name": "Path 2520",
    d: "M0,0H12",
    transform: "translate(116.494 420.885)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_65",
    "data-name": "Line 65",
    x2: 12,
    transform: "translate(144.542 420.885)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_66",
    "data-name": "Line 66",
    x2: 12,
    transform: "translate(172.542 420.885)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_67",
    "data-name": "Line 67",
    x2: 12,
    transform: "translate(201.542 420.885)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_68",
    "data-name": "Line 68",
    x2: 12,
    transform: "translate(229.542 420.885)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_69",
    "data-name": "Line 69",
    x2: 12,
    transform: "translate(257.542 420.885)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_71",
    "data-name": "Line 71",
    x2: 12,
    transform: "translate(285.542 420.885)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_72",
    "data-name": "Line 72",
    x2: 12,
    transform: "translate(314.542 420.885)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_81",
    "data-name": "Line 81",
    x2: 12,
    transform: "translate(60.542 420.885)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_73",
    "data-name": "Line 73",
    x2: 12,
    transform: "translate(343.542 420.885)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_82",
    "data-name": "Line 82",
    x2: 12,
    transform: "translate(87.542 420.885)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_74",
    "data-name": "Line 74",
    x2: 12,
    transform: "translate(370.542 420.885)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_216",
    "data-name": "Ellipse 216",
    transform: "translate(336 342)",
    fill: "#fff",
    stroke: "#75baf5",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Trophy",
    transform: "translate(3.006 -38.119)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1933",
    "data-name": "Group 1933",
    transform: "translate(340.15 391.145)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-trophy",
    "data-name": "Icon metro-trophy",
    d: "M26,7.461v-3.6H7.978v3.6H2.571v3.6A5.411,5.411,0,0,0,9.6,16.224,9.016,9.016,0,0,0,15.187,19.9v5.587h-1.8a3.6,3.6,0,0,0-3.6,3.6H24.2a3.6,3.6,0,0,0-3.6-3.6h-1.8V19.9a9.016,9.016,0,0,0,5.587-3.672,5.411,5.411,0,0,0,7.03-5.159v-3.6ZM7.978,14.332a3.27,3.27,0,0,1-3.267-3.267v-1.8H7.978v1.8a8.99,8.99,0,0,0,.59,3.212,3.271,3.271,0,0,1-.59.054Zm21.29-3.267a3.263,3.263,0,0,1-3.857,3.212A8.99,8.99,0,0,0,26,11.065v-1.8h3.267v1.8Z",
    transform: "translate(-2.57 -3.856)",
    fill: "#f2b90f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_4",
    "data-name": "Subtraction 4",
    d: "M11.545,25.232H7.211a3.607,3.607,0,0,1,3.6-3.605h.734v3.6Zm0-9.479h0a9.116,9.116,0,0,1-4.516-3.389A5.406,5.406,0,0,1,0,7.206V3.6H5.406V0h6.139V15.753ZM2.139,5.408h0v1.8a3.273,3.273,0,0,0,3.268,3.271A3.558,3.558,0,0,0,6,10.423a8.982,8.982,0,0,1-.59-3.217v-1.8Z",
    transform: "translate(0 0.001)",
    fill: "#f29f05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_5",
    "data-name": "Subtraction 5",
    d: "M11.544,0H7.21a3.607,3.607,0,0,0,3.6,3.6h.734V0Zm0,9.478h0a9.1,9.1,0,0,0-4.515,3.389A5.405,5.405,0,0,0,0,18.026v3.6H5.406v3.6h6.138V9.479ZM2.138,19.824h0v-1.8a3.273,3.273,0,0,1,3.268-3.27A3.53,3.53,0,0,1,6,14.81a8.978,8.978,0,0,0-.59,3.216v1.8Z",
    transform: "translate(28.838 25.232) rotate(180)",
    fill: "#f29f05"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgrssWithTrophy);
export default __webpack_public_path__ + "static/media/progrss_with_trophy.66600b6bb3372815b93ea2494d2bbb8d.svg";
export { ForwardRef as ReactComponent };